// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".powered-by-reality[data-v-09370f87]{position:fixed;bottom:7px;right:9px;height:16px;text-decoration:none}.powered-by-reality img[data-v-09370f87]{height:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
